import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

const messageResponseReducer = (state = InitialState.messageResponseReducer, action) => {
    switch (action.type) {
        case ActionType.API_CALL_ERROR: {
            return {
                ...state,
                messages: _.assign(action.messages),
                messageSuccess:null
            }
        }
        case ActionType.API_CALL_SUCCESS: {
            return {
                ...state,
                messages: [],
                messageSuccess: _.assign(action.messageSuccess)
            }
        }
        default: { return state; }
    }
}

export default messageResponseReducer;